import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Query } from '@services/core-services/models';
import { Payment, PaymentModal, Payments } from '@services/payment-services/models';
import { PaginatedList } from '@services/core-services/models/paginated-list';
import { PaymentListResponse } from './models/payment-list.response';
import { PaymentDetailResponse } from './models/payment-detail.response';
import { PaymentId } from './models/payment-id';
import { CachingApiService } from '@services/core-services/api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  paymentUrl = 'orders/payments';

  constructor(private readonly cacheApi: CachingApiService) {}

  getAllPaymentData(query?: Query): Observable<PaginatedList<Payments[]>> {
    return this.cacheApi.getWithCache<PaymentListResponse>(this.paymentUrl, query).pipe(
      map(({ content }: PaymentListResponse) => ({
        list: content.payments,
        pagination: content.pagination,
      }))
    );
  }

  paymentDetail(paymentId: PaymentId): Observable<Payment> {
    const urlId = `${this.paymentUrl}/${paymentId}`;
    return this.cacheApi.getWithCache<PaymentDetailResponse>(urlId).pipe(
      map((response: PaymentDetailResponse) => {
        return response.content.payment;
      })
    );
  }

  refundPayment(refundPayment: any): Observable<PaymentModal> {
    const refundUrl = `${this.paymentUrl}/refund`;
    return this.cacheApi
      .post(refundUrl, refundPayment)
      .pipe(map((response: any) => response.content.payments as PaymentModal));
  }

  cancelPayment(paymentId: PaymentId): Observable<PaymentId> {
    const urlId = `${this.paymentUrl}/${paymentId}/cancel`;
    return this.cacheApi.post(urlId, paymentId);
  }
}
